(function() {
	'use strict';
	angular.module('app.setup')
		.controller('projectAreaForm', projectAreaForm);

	projectAreaForm.$inject = ['$scope', 'projectAreaService', 'storeService'];
	function projectAreaForm($scope, projectAreaService, storeService) {
		var vm = this;
		var adminConfig = storeService.getState().adminConfig;
		// view model functions
		vm.projectArea = $scope.projectArea;
		vm.leanDirFactoryNdx = $scope.leanDirFactoryNdx;
		vm.isSaveButtonDisabled = false;
		vm.action = $scope.action;
		vm.close = close;
		vm.save = save;
		init();
		
		function init() {
			if (vm.action == 'Edit') {
				vm.originalProjectArea = jQuery.extend({}, vm.projectArea, true); 
			} 
			else {
				vm.projectArea = {
					factoryNdx: vm.leanDirFactoryNdx
				};
			}
		}

		function save() {
			vm.isSaveButtonDisabled = true;
			if (typeof vm.projectArea.id === 'undefined') {
				vm.projectArea.factoryNdx = vm.leanDirFactoryNdx;
				projectAreaService.addProjectArea(vm.projectArea, adminConfig.factory.id).then(function(message) {
					$scope.result(message, message == 'Project area created successfully');
					vm.isSaveButtonDisabled = false;
				});
			} else {
				var lastModified = (typeof vm.projectArea.lastModified === 'undefined') ? (new Date()).toUTCString() : (new Date(vm.projectArea.lastModified)).toUTCString();
				if (vm.projectArea.name !== vm.originalProjectArea.name) {
					var projectType = {
						id: vm.projectArea.id,
						name: vm.projectArea.name,
						factoryNdx: vm.leanDirFactoryNdx
					};
					projectTypeService.updateProjectArea(projectType, lastModified, adminConfig.factory.id).then(function (message) {
						if (_.isString(message)) { 
							$scope.result(message, false);
						} else {
							$scope.result('Project area updated successfully', message.data.id == vm.projectArea.id);
						}
					});
				} else {
					$scope.result('', true);
				}
				vm.isSaveButtonDisabled = false;
			}
		}
		
		function close() {
			$scope.result('', false);
		}
	}
})();
